<template>
  <div>
    <h6>Integrations Portal</h6>

    <span v-if="loading">
      <i class="fas fa-spinner fa-spin grey-text"></i>
      Checking connection...
    </span>

    <span v-else-if="!reachable" class="grey-text text-darken-1">
      <i class="fas fa-exclamation-triangle"></i>
      Portal not reachable — try again later.
    </span>

    <template v-else-if="connected">
      <i class="fas fa-check emerald"></i>
      <span class="badge-emerald-outlined ml-5">Connected</span>
      <a class="btn-flat grey-text ml-10" :class="{ disabled: disabled }" @click="disconnect">
        <i class="fas fa-unlink"></i>
        Disconnect
      </a>
    </template>

    <a v-else class="btn btn-large" :class="{ disabled: disabled }" @click="connect">
      <i class="fas fa-plug"></i>
      {{ connectLabel }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    connected: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: true,
      reachable: true,
      disabled: false,
      status: null
    }
  },
  computed: {
    connectLabel() {
      return this.status === "disconnected" ? "Reconnect Integrations Portal" : "Connect Integrations Portal"
    }
  },
  mounted() {
    this.checkStatus()
  },
  methods: {
    checkStatus() {
      this.$http.get("/api/v1/integrations_portal/connection").then(response => {
        this.applyState(response.body)
        this.loading = false
      }, () => {
        this.reachable = false
        this.loading = false
      })
    },
    connect() {
      if (this.disabled) { return }

      this.disabled = true
      this.$http.post("/api/v1/integrations_portal/connection").then(response => {
        this.connected = response.body.connected
        this.status = "connected"
        this.disabled = false
        this.notifySuccess("Integrations Portal connected")
      }, error => {
        this.disabled = false
        this.notifyError(this.errorMessage(error, "Connection failed"))
      })
    },
    disconnect() {
      if (this.disabled) { return }
      if (!window.confirm("Disconnect the Integrations Portal? Transactions stop syncing until you reconnect.")) { return }

      this.disabled = true
      this.$http.delete("/api/v1/integrations_portal/connection").then(response => {
        this.connected = response.body.connected
        this.status = "disconnected"
        this.disabled = false
        this.notifySuccess("Integrations Portal disconnected")
      }, error => {
        this.disabled = false
        this.notifyError(this.errorMessage(error, "Disconnect failed"))
      })
    },
    applyState(body) {
      this.connected = body.connected
      this.reachable = body.reachable
      this.status = body.status
    },
    errorMessage(error, fallback) {
      const messages = error.body && error.body.error_messages
      return messages && messages[0] ? messages[0] : fallback
    }
  }
}
</script>
